import React from 'react'
import { useState, useEffect } from 'react'
import { parameterize } from 'inflected';
import { Icon } from 'react-icons-kit'
import {compress} from 'react-icons-kit/fa/compress'
import {expand} from 'react-icons-kit/fa/expand'
import classNames from 'classnames'
import { Slide, Zoom } from "react-awesome-reveal"

export default function BlogToc() {
  const [tocArray, setTocArray] = useState([]);

  const initToc = () => {
    const articleEl = document.getElementById("article-container");

    let tocArray = [];

    for (const child of articleEl.children) {
      const tag = child.tagName.toLowerCase();
      const isHeaderTag = tag[0] === 'h';

      if(isHeaderTag) {
        const text = child.innerText;
        const id= parameterize(text);
        child.id = id;
        tocArray.push( { tag, id, text } );
      }

    }
    setTocArray(tocArray);
  }
  
  const contentsUI = () => (
    <Zoom direction={'up'} delay={0} duration={2000} triggerOnce={true}>
      <div>
        <ul>
          { 
            tocArray.map(
              (item, i) => (
                <li key={i} className={`toc-item item-${item.tag}` }>
                  <a href={'#' + item.id}>{item.text}</a>
                </li>
              )
            )
          }
        </ul>
      </div>
    </Zoom>
  )

  const classes = {
    blogTocComponent: classNames(
      'blog-toc-component', 
    ),
  }

  useEffect(() => {
    initToc()
    // window.addEventListener( "DOMContentLoaded", initToc); 
  }, []);

  return (
    <div className={classes.blogTocComponent} >
      { contentsUI() }
      <div style={{clear: 'both'}}/>
    </div>
  )
}
